import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import { defaultRejectHandler, stringifyErrorMessage } from '../../utils/utility';
import { searchHeatToElectricalEnergyByText } from '../../redux/renewable_energy/heat_to_electrical_energy_actions';

import {
  addHeatToElectricalEnergyToBuilding,
  editHeatToElectricalEnergyInBuilding,
  listHeatToElectricalEnergyInBuilding,
  removeHeatToElectricalEnergyFromBuilding,
} from '../../redux/projects/project_heat_to_electrical_energy_actions';
import { getProject } from '../../redux/projects/projects_actions';


export class HeatToElectricalEnergyDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'heat_to_electrical.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'heat_to_electrical.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchHeatToElectricalEnergyByText(text, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
          create: null,
        },
      },
      {
        Header: () => <b>{`${t('entropy')} (${t('MJ/ton')})`}</b>,
        accessor: 'heat_to_electrical.entropy',
        ...coeColumn,
      },
      {
        Header: () => <b>{`${t('volume')} (${t('ton/year')})`}</b>,
        accessor: 'heat_to_electrical.volume',
        ...coeColumn,
      },
     {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        width: 80,
        ...decimalColumn,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {};
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    this.props.listHeatToElectricalEnergy(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );
    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      buildingId,
      filtered,
      filteredCount,
      isHeatToElectricalEnergyLoading,
      addHeatToElectricalEnergy,
      editHeatToElectricalEnergy,
      removeHeatToElectricalEnergy,
      isHeatToElectricalEnergyAdding,
      isHeatToElectricalEnergyEditing,
      isHeatToElectricalEnergyRemoving,
      errorMessage,
    } = this.props;

    const relationship = {
      create: ({ entityId, quantity, azimuth_angle, inclination }) => addHeatToElectricalEnergy(entityId, buildingId, quantity,azimuth_angle, inclination),
      edit: ({ id, quantity, azimuth_angle, inclination }) => editHeatToElectricalEnergy(id, quantity, azimuth_angle, inclination),
      delete: id => removeHeatToElectricalEnergy(id, buildingId),
      isCreating: isHeatToElectricalEnergyAdding,
      isEditing: isHeatToElectricalEnergyEditing,
      isDeleting: isHeatToElectricalEnergyRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={this.columns}
          data={this.props.relationships}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.heat_to_electrical.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isHeatToElectricalEnergyLoading}
          onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  relationships: state.projectRE.heatToElectricalEnergy.orderedIds.map(id => state.projectRE.heatToElectricalEnergy.objects[id]),
  filteredCount: state.projectRE.heatToElectricalEnergy.filteredCount,
  isHeatToElectricalEnergyLoading: state.projectRE.heatToElectricalEnergy.isLoading,
  isHeatToElectricalEnergyAdding: state.projectRE.heatToElectricalEnergy.isCreating,
  isHeatToElectricalEnergyEditing: state.projectRE.heatToElectricalEnergy.isEditing,
  isHeatToElectricalEnergyRemoving: state.projectRE.heatToElectricalEnergy.isDeleting,
  errorMessage: state.projectRE.heatToElectricalEnergy.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  listHeatToElectricalEnergy: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listHeatToElectricalEnergyInBuilding(pageSize, page, sorted, filtered, isPublic, props.buildingId))),
  addHeatToElectricalEnergy: (heatToElectricalEnergyId, buildingId, quantity, azimuth, inclination) =>
    defaultRejectHandler(dispatch(addHeatToElectricalEnergyToBuilding(heatToElectricalEnergyId, buildingId, quantity, azimuth, inclination))
      .then(() => dispatch(getProject(props.projectId)))),
  editHeatToElectricalEnergy: (buildingHeatToElectricalEnergyId, quantity, azimuth, inclination) =>
    defaultRejectHandler(dispatch(editHeatToElectricalEnergyInBuilding(buildingHeatToElectricalEnergyId, quantity, azimuth, inclination))
      .then(() => dispatch(getProject(props.projectId)))),
  removeHeatToElectricalEnergy: (buildingHeatToElectricalEnergyId, buildingId) =>
    defaultRejectHandler(dispatch(removeHeatToElectricalEnergyFromBuilding(buildingHeatToElectricalEnergyId, buildingId))
      .then(() => dispatch(getProject(props.projectId)))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(HeatToElectricalEnergyDataTable),
);



// WEBPACK FOOTER //
// ./src/components/project_detail/HeatToElectricalEnergyDataTable.js